import React, { useEffect, useState } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import FilterTopBar from '../../../shared/components/FilterTopBar';

import { UserProps } from '../../../shared/prop-types/ReducerProps';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';
import TopbarMail from './TopbarMail';
import TopbarNotification from './TopbarNotification';
import TopbarSearch from './TopbarSearch';
import TopbarLanguage from './TopbarLanguage';
import { apiUrls } from '../../../utils/api/api-urls';
import {
  getMarketPlaceDetails, getMarketPlaceDetailsError, setSalesChannelFILTERS
} from '../../../redux/actions/marketPlaceAction';
import REQUEST from '../../../utils/services';

const Topbar = ({
  changeMobileSidebarVisibility, changeSidebarVisibility, user, dispatch,
}) => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const { marketPlaceData } = useSelector(({ marketPlaceReducer }) => marketPlaceReducer);

  const changeFilter = (val) => {
    dispatch(setSalesChannelFILTERS(val));
  };

  const getMarketPlaceData = async () => {
    const res = await REQUEST(apiUrls.marketplace.getMarketplace);
    if (res) {
      dispatch(getMarketPlaceDetails({ data: res }));
    } else {
      dispatch(getMarketPlaceDetailsError(t('invalid user Please try again')));
    }
  };
  useEffect(() => {
    getMarketPlaceData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="topbar">
      <div className="topbar__left">
        <TopbarSidebarButton
          changeMobileSidebarVisibility={changeMobileSidebarVisibility}
          changeSidebarVisibility={changeSidebarVisibility}
        />
        <Link className="topbar__logo" to="/dashboard">
          <span className="logo">Rael</span> Smart System
        </Link>
      </div>
      <div className="topbar__right">
        <div className="topbar__right-search" />
        <div className="topbar__right-over">
          <TopbarProfile user={user} />
        </div>
        <div className="topbar__right-filter">
          <FilterTopBar
            filter={marketPlaceData?.modal?.filters}
            callback={changeFilter}
          />
        </div>
      </div>
    </div>
  );
};

Topbar.propTypes = {
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
  changeSidebarVisibility: PropTypes.func.isRequired,
  user: UserProps,
  dispatch: PropTypes.func.isRequired,
};

Topbar.defaultProps = {
  user: {},
};

export default connect()(Topbar);
